/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConstructionDayReport } from '../../models/construction-day-report';

export interface ApiV0ConstructiondayreportGetConstructionDayReportsForConstructionSiteGet$Json$Params {
  conSiteId?: string;
}

export function apiV0ConstructiondayreportGetConstructionDayReportsForConstructionSiteGet$Json(http: HttpClient, rootUrl: string, params?: ApiV0ConstructiondayreportGetConstructionDayReportsForConstructionSiteGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ConstructionDayReport>>> {
  const rb = new RequestBuilder(rootUrl, apiV0ConstructiondayreportGetConstructionDayReportsForConstructionSiteGet$Json.PATH, 'get');
  if (params) {
    rb.query('conSiteId', params.conSiteId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ConstructionDayReport>>;
    })
  );
}

apiV0ConstructiondayreportGetConstructionDayReportsForConstructionSiteGet$Json.PATH = '/api/v0/constructiondayreport/getConstructionDayReportsForConstructionSite';
